import { Message } from '../../models/message';

export class AddMessage {
    public static readonly type = '[MessagingState] Add message';

    constructor(public message: Message) {}
}
